module.exports = require('./helpers/bundle-url').getBundleURL('7R2cq') + "logo.c51670a8.svg";